<template>
    <div>
        <HeaderTopComponent  v-if="!menuMovil" />
        <MenuComponent 
            background='' 
            :dense='false' 
            
            styleRow='margin-top: 0px'
            v-if="!menuMovil"
        />
        <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10'/>
        <BreadCrumbsComponent  :breadcrumbs="breadcrumbs" :class="`margin-breadcrumb ${scrollTop ? '' : 'mt-132'}`"/>
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-16 py-2">
            <div class="text-md-h3 text-h4 text-sm-h3 primary--text mt-md-16 font-title"><b><i>CORONAVIRUS</i></b></div>
            <h2 class="gray--text font-title"><i>COVID19</i></h2>
            <div class='grayblack--text mt-5'>En nuestros laboratorios trabajamos para contribuir en este momento de emergencia sanitaria, razón por la cual, proporcionamos el hisopado PCR, y la prueba de anticuerpos Img- IgM, bajo las normas de calidad internacional.</div>
            <div class='grayblack--text mt-5'>Solicite <a class='blue--text' href="#">su turno</a> para realizarlo</div>
        </div>
        <div class='mt-10 background-covid font-text'>
            <div class='mx-info'>
                <div class='px-5 py-3 primary--text title-info text-center text-md-3 text-lg-h4 font-weight-black'>RECOMENDACIONES</div>
                <div class='mt-10  grayblack--text font-subtitle-2 ml-md-8'>
                    Ante la presencia de dos o más de los siguiente síntomas: 
                    <br /> <b>fiebre, tos, dolor de garganta, dificultad respiratoria, dolor muscular, cefalea, diarrea y/o vómitos.</b>
                    <br />
                    O si solo perdió el gusto o el olfato, consulte inmediatamente al sistema de salud en su localidad
                </div>
                <div class='px-5 mt-16 py-3 primary--text title-info text-center text-md-4 text-lg-h5 font-weight-black font-title'>Para prevenir el contagio:</div>
                <div class='mt-10  grayblack--text ml-md-8 font-text'>
                    <ul>
                        <li class='font-weight-black'><b>Mantenga la distancia prudencial de 2 metros</b></li>
                        <li class='font-weight-black'><b>Use mascarilla</b></li>
                        <li class='font-weight-black'><b>Evite reuniones en espacios cerrados</b></li>
                        <li class='font-weight-black'><b>Si tiene necesidad de toser o estornudar cubra su nariz y su boca, estornudando en el pliegue del brazo.</b></li>
                        <li class='font-weight-black'><b>Ventile y desinfecte los ambientes</b></li>
                        <li class='font-weight-black'><b>Lávese las manos frecuentemente con agua y jabón o utilice soluciones a base de alcohol</b></li>
                        <li class='font-weight-black'><b>Limpie los objetos que usa con frecuencia.</b></li>
                    </ul>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'
import CardServiciosComponent from '../partials/CardServiciosComponent'
import MenuMovilComponent from '../partials/MenuMovilComponent'
import {mapState} from 'vuex'

export default {
    name:'Covid12Component',
    data: ()=>({
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Covid19',url:'/covid19'}
        ],
    }),
    components:{
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        BreadCrumbsComponent,
        CardServiciosComponent,
        MenuMovilComponent  
    },
    computed:{
        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },
        ...mapState(['scrollTop'])
    },
}
</script>

<style>
    .background-covid{
        background-image: url("../../../../assets/background-covid.png");
        background-size: cover;
        border-radius: 10px!important;
        height: 1000px;
    }

    .mx-info{
        width: 30%;
        margin: 0 auto;
        position: relative;
        top:15%;
    }

    .title-info{
        margin: 0 auto;
        background-color:white;
        border-radius:30px
    }

    li{
        margin: 10px 0
    }
    .v-application .text-md-h3, .v-application .text-md-3,.v-application .text-md-4{
        font-family: Asap!important;
    }

    @media(max-width: 767px){
        .mx-info{
            width: 89%;
        }
    }


</style>